export function useSetStorageValue(key: string) {
    const setValue = (value: any) => {
        if (typeof window !== 'undefined') {
            window.localStorage.setItem(key, value);
        }
    };

    return setValue;
}
